import $ from 'jquery';
import {forEach} from 'ramda';
import rmc from '../../scripts/util/dom/rmc';

export const setHeight = (wrapper, content) => {
	const height = content.outerHeight();
	wrapper.css('height', height + 'px');
};

export default class {
	constructor(options) {
		const defaults = {
			el: '.js-filter',

			dom: {
				list: '.js-filter-list',
				nav: '.js-filter-nav',
				items: '.js-filter-items',
				content: '.js-filter-items-wrap',
				clean: '.js-filter-clean',
				link: '.js-filter-link',

				checkbox: {
					el: '.js-filter-checkbox',
					input: '.js-checkbox-input',
					label: '.js-checkbox-label'
				},

				search: {
					el: '.js-filter-search',
					field: '.js-field',
					input: '.js-field-input'
				}
			},

			classes: {
				filter: {
					state: {
						open: 'filter__list_state_open',
						opened: 'filter__list_state_opened',
						active: 'filter__list_state_active'
					}
				},
				checkbox: {
					state: {
						active: 'filter__checkbox_state_active'
					}
				}
			}
		};

		this.options = $.extend(true, {}, defaults, options);
		this.$el = $(this.options.el);
	}

	getDom() {
		this.$list = this.$el.find(this.options.dom.list);
		this.$nav = this.$el.find(this.options.dom.nav);
		this.$items = this.$el.find(this.options.dom.items);
		this.$content = this.$el.find(this.options.dom.content);
		this.$clean = this.$el.find(this.options.dom.clean);
		this.$input = this.$el.find(this.options.dom.checkbox.input);
		this.$link = this.$el.find(this.options.dom.link);
		this.$search = this.$el.find(this.options.dom.search.field);
		this.$filterSearch = this.$el.find(this.options.dom.search.el);
		this.$searchInput = this.$search.find(this.options.dom.search.input);
		this.$checkboxFilter = this.$el.find(this.options.dom.checkbox.el);
		this.open = this.options.classes.filter.state.open;
		this.opened = this.options.classes.filter.state.opened;
		this.active = this.options.classes.filter.state.active;
		this.checkboxActive = this.options.classes.checkbox.state.active;
		return this;
	}

	close = elem => {
		rmc(this.opened, elem);
		$(elem).find(this.$items).css('height', 0);
	};

	onClick(e) {
		const $target = $(e.target);
		const $list = $target.closest(this.$list);
		const $items = $list.find(this.$items);
		const $content = $list.find(this.$content);
		forEach(this.close, this.$list);
		if (!$list.hasClass(this.opened)) {
			$list.addClass(this.opened);
			setHeight($items, $content);
		}
		else {
			$list.removeClass(this.opened);
			$items.css('height', 0);
		}
	}

	onShow(e) {
		const $target = $(e.target);
		const $list = $target.closest(this.$list);
		const $input = $list.find(this.$input).is(':checked');
		if ($input) {
			$list.addClass(this.active);
		}
		else {
			$list.removeClass(this.active);
		}
	}

	onLoad() {
		const self = this;

		self.$list.each(function () {
			const $list = $(this);
			const $input = $list.find(self.$input).is(':checked');
			if ($input) {
				$(this).addClass(self.active);
			}
			else {
				$(this).removeClass(self.active);
			}
		});
	}

	reset(e) {
		const $target = $(e.target);
		const $list = $target.closest(this.$list);
		const $input = $list.find(this.$input);
		$input.attr('checked', false);
		$list.removeClass(this.active);
	}

	onClickLink(e) {
		const $target = $(e.target);
		const $list = $target.closest(this.$list);
		$list.toggleClass(this.open);
	}

	changeSearch(e) {
		const $thisInput = $(e.target);
		if (this.validate($thisInput)) {
			this.searchFilter($thisInput);
		} else {
			this.resetResult();
		}
	}

	showCheckbox(el) {
		el.removeClass(this.checkboxActive);
	}

	hideCheckbox(el) {
		el.addClass(this.checkboxActive);
	}

	resetResult() {
		this.$checkboxFilter.removeClass(this.checkboxActive);
	}

	validate(el) {
		const val = el.val().replace(/\s+/g, '');
		if (val.length) {
			return true;
		}
		return false;
	}

	searchFilter(el) {
		const self = this;
		const $thisInput = el;
		const searchValue = $thisInput.val().toLowerCase().replace(/\s+/g, '');
		const $parent = $thisInput.closest(self.$filterSearch);
		const $items = $parent.siblings(self.$items);
		const $checkbox = $items.find(self.options.dom.checkbox.el);

		$checkbox.each(function () {
			const $thisCheckbox = $(this);
			const $thisLabel = $thisCheckbox.find(self.options.dom.checkbox.label);
			const labelText = $thisLabel.text().toLowerCase().replace(/\s+/g, '');
			const regex = new RegExp(searchValue);

			if (regex.test(labelText)) {
				self.showCheckbox($thisCheckbox);
			} else {
				self.hideCheckbox($thisCheckbox);
			}
		});
	}

	render() {
		if (this.$el.length) {
			this.getDom();
			this.$nav.on('click', this.onClick.bind(this));
			this.$clean.on('click', this.reset.bind(this));
			this.$input.on('click', this.onShow.bind(this));
			this.$link.on('click', this.onClickLink.bind(this));
			$(window).on('load', this.onLoad.bind(this));
			this.$search.on('keypress keydown focus blur input paste change', this.changeSearch.bind(this));

		}
		return this;
	}
}



/** WEBPACK FOOTER **
 ** ./app/blocks/filter/filter.js
 **/